import { UPDATE_CATEGORY_REDUCER } from "../actionTypes";

const initialState = {
allData:[]

}

export const categoryReducer = (state=initialState, action) => {
    switch (action.type) {
        case UPDATE_CATEGORY_REDUCER:
            return {
                ...state,
                allData:action?.payload
            }

        default:
            state = { ...state };
            break;
    }
    return state;
};